module.exports = __webpack_public_path__ + "79d2cff7fff54b68465278701210d3d8.png";